// extracted by mini-css-extract-plugin
export default {"sidebar":"w_b9","sidebarHeader":"w_cb","fileinput":"w_cc","form":"w_cd","sponsoredText":"w_cf"};